{
 "version": 1,
 "notes": "First batch (2026-10-02): V-47 Medved and VS-12 Kaban with the 49 parts that fit them. Second batch: P-11, K-5, S-10 (9×19, pistol ammo) with 26 parts. Full catalog: docs/weapons/gunsmith-catalog.json. How to add guns: docs/WEAPONS.md.",
 "mapping": {
  "spreadPerMoa": 0.0083,
  "climbPerRecV": 0.006,
  "wobblePerRecH": 0.003,
  "recoverPerS": 6,
  "recoverDelay": 0.15,
  "bloomMaxDeg": 9,
  "readyBase": 0.65,
  "readyErgo": 0.45,
  "walkFreeKg": 1.5,
  "walkPerKg": 0.015,
  "walkMax": 0.12,
  "pxPerM": 6.6,
  "speedBase": 324,
  "speedPerMs": 0.6,
  "noisePx": 4.8,
  "lookPx": 36,
  "lookMax": 240,
  "driveByMaxCm": 75
 },
 "makers": {
  "severka": {
   "name": "Severka Kombinat"
  },
  "hachi": {
   "name": "Hachi's house brand"
  },
  "halvard": {
   "name": "Halvard Defense"
  },
  "oshiro": {
   "name": "Oshiro Precision"
  },
  "sumida": {
   "name": "Sumida Ordnance"
  },
  "kanemori": {
   "name": "Kanemori Heavy"
  },
  "mirai": {
   "name": "Mirai"
  },
  "kenji": {
   "name": "Kenji Arms"
  }
 },
 "calibers": {
  "762r": {
   "name": "7.62×39 mm",
   "pool": "762r"
  },
  "12ga": {
   "name": "12 gauge",
   "pool": "12ga"
  },
  "9x19": {
   "name": "9×19 mm",
   "pool": "pistol"
  }
 },
 "types": {
  "barrel": "Barrel",
  "muzzle": "Muzzle device",
  "suppressor": "Suppressor",
  "handguard": "Handguard",
  "foregrip": "Foregrip",
  "tactical": "Tactical device",
  "rail": "Rail section",
  "optic": "Optic",
  "mount": "Mount",
  "dustcover": "Dust cover",
  "stock": "Stock",
  "tube": "Buffer tube",
  "grip": "Pistol grip",
  "magazine": "Magazine",
  "module": "Smart link"
 },
 "platforms": [
  {
   "id": "v47",
   "name": "V-47 Medved",
   "maker": "severka",
   "cls": "rifle",
   "based": "AKM-type rifle",
   "caliber": "762r",
   "modes": [
    "semi",
    "auto"
   ],
   "role": "Hard-hitting rifle",
   "blurb": "Hits harder than the V-74 and kicks harder too. Shares all its furniture.",
   "pellets": 1,
   "stockTarget": {
    "damage": 22,
    "rpm": 300,
    "vel": 715,
    "range": 80,
    "recV": 150,
    "recH": 330,
    "ergo": 47,
    "weight": 3.6,
    "noise": 96,
    "reload": 2.2,
    "price": 1050
   },
   "slots": [
    {
     "id": "barrel",
     "label": "Barrel",
     "types": [
      "barrel"
     ],
     "mounts": [
      "b-v47"
     ],
     "req": true
    },
    {
     "id": "handguard",
     "label": "Handguard",
     "types": [
      "handguard"
     ],
     "mounts": [
      "hg-ak"
     ],
     "req": true
    },
    {
     "id": "dustcover",
     "label": "Dust cover",
     "types": [
      "dustcover"
     ],
     "mounts": [
      "dc-ak"
     ],
     "req": true
    },
    {
     "id": "stock",
     "label": "Stock",
     "types": [
      "stock"
     ],
     "mounts": [
      "st-ak"
     ]
    },
    {
     "id": "grip",
     "label": "Pistol grip",
     "types": [
      "grip"
     ],
     "mounts": [
      "pg-ak"
     ],
     "req": true
    },
    {
     "id": "mag",
     "label": "Magazine",
     "types": [
      "magazine"
     ],
     "mounts": [
      "m-762r"
     ],
     "req": true
    }
   ],
   "defaults": {
    "barrel": "v47_bar_std",
    "barrel/muzzle": "m762r_brake",
    "handguard": "ak_hg_wood",
    "dustcover": "ak_dc_std",
    "stock": "ak_st_wood",
    "grip": "ak_pg_std",
    "mag": "m762r_30"
   },
   "presets": [
    {
     "name": "Bear drum",
     "parts": {
      "barrel": "v47_bar_std",
      "barrel/muzzle": "m762r_brake",
      "handguard": "ak_hg_quad",
      "handguard/foregrip": "fg_gyro",
      "handguard/tactical": "tac_light",
      "dustcover": "ak_dc_rail",
      "dustcover/optic": "opt_holo",
      "stock": "ak_st_poly",
      "grip": "ak_pg_rub",
      "mag": "m762r_75"
     }
    },
    {
     "name": "Quiet bear",
     "parts": {
      "barrel": "v47_bar_std",
      "barrel/muzzle": "s762r",
      "handguard": "ak_hg_poly",
      "handguard/foregrip": "fg_angled",
      "dustcover": "ak_dc_rail",
      "dustcover/optic": "opt_reflex",
      "stock": "ak_st_skel",
      "grip": "ak_pg_erg",
      "mag": "m762r_30"
     }
    }
   ],
   "draw": {
    "body": "ak",
    "R": 31,
    "H": 6.4,
    "bore": 4.6,
    "gx": 8,
    "mx": 16,
    "top": 15,
    "sy": [
     1.6,
     6
    ]
   },
   "base": {
    "damage": 22,
    "rpm": 300,
    "vel": 715,
    "range": 80,
    "recV": 250,
    "recH": 550,
    "ergo": 47,
    "weight": 1.24,
    "noise": 93,
    "reload": 2.2,
    "price": 700,
    "len": 31
   }
  },
  {
   "id": "vs12",
   "name": "VS-12 Kaban",
   "maker": "severka",
   "cls": "shotgun",
   "based": "AK-pattern magazine shotgun (Saiga-12-type)",
   "caliber": "12ga",
   "modes": [
    "semi"
   ],
   "role": "Semi-auto shotgun",
   "blurb": "A box-fed shotgun on the Severka action, so the whole Severka parts bin fits.",
   "pellets": 8,
   "stockTarget": {
    "damage": 8,
    "rpm": 110,
    "vel": 410,
    "range": 34,
    "recV": 260,
    "recH": 380,
    "ergo": 40,
    "weight": 3.9,
    "noise": 96,
    "reload": 2.8,
    "price": 1250
   },
   "slots": [
    {
     "id": "barrel",
     "label": "Barrel",
     "types": [
      "barrel"
     ],
     "mounts": [
      "b-vs12"
     ],
     "req": true
    },
    {
     "id": "handguard",
     "label": "Handguard",
     "types": [
      "handguard"
     ],
     "mounts": [
      "hg-ak"
     ],
     "req": true
    },
    {
     "id": "dustcover",
     "label": "Dust cover",
     "types": [
      "dustcover"
     ],
     "mounts": [
      "dc-ak"
     ],
     "req": true
    },
    {
     "id": "stock",
     "label": "Stock",
     "types": [
      "stock"
     ],
     "mounts": [
      "st-ak"
     ]
    },
    {
     "id": "grip",
     "label": "Pistol grip",
     "types": [
      "grip"
     ],
     "mounts": [
      "pg-ak"
     ],
     "req": true
    },
    {
     "id": "mag",
     "label": "Magazine",
     "types": [
      "magazine"
     ],
     "mounts": [
      "m-12box"
     ],
     "req": true
    }
   ],
   "defaults": {
    "barrel": "vs12_bar_std",
    "handguard": "ak_hg_poly",
    "dustcover": "ak_dc_std",
    "stock": "ak_st_poly",
    "grip": "ak_pg_std",
    "mag": "m12_8"
   },
   "presets": [
    {
     "name": "Breacher",
     "parts": {
      "barrel": "vs12_bar_std",
      "barrel/muzzle": "ch12_wide",
      "handguard": "ak_hg_quad",
      "handguard/foregrip": "fg_vert",
      "handguard/tactical": "tac_light",
      "dustcover": "ak_dc_std",
      "stock": "ak_st_fold",
      "grip": "ak_pg_rub",
      "mag": "m12_20"
     }
    },
    {
     "name": "Mute",
     "parts": {
      "barrel": "vs12_bar_long",
      "barrel/muzzle": "s12",
      "handguard": "ak_hg_poly",
      "handguard/foregrip": "fg_angled",
      "dustcover": "ak_dc_rail",
      "dustcover/optic": "opt_holo",
      "stock": "ak_st_poly",
      "grip": "ak_pg_erg",
      "mag": "m12_8"
     }
    }
   ],
   "draw": {
    "body": "ak",
    "R": 35,
    "H": 6.8,
    "bore": 4.8,
    "gx": 9,
    "mx": 18,
    "top": 17,
    "sy": [
     1.6,
     6.3
    ]
   },
   "base": {
    "damage": 8,
    "rpm": 110,
    "vel": 410,
    "range": 34,
    "recV": 371.4,
    "recH": 542.9,
    "ergo": 39,
    "weight": 1.67,
    "noise": 96,
    "reload": 2.692,
    "price": 890,
    "len": 35
   }
  },
  {
   "id": "p11",
   "name": "P-11 Hayate",
   "maker": "kenji",
   "cls": "pistol",
   "based": "Select-fire machine pistol (Glock 18-type)",
   "caliber": "9x19",
   "modes": [
    "semi",
    "auto"
   ],
   "role": "Glass-cannon sidearm",
   "blurb": "Full auto in a pistol frame. Empties a mag in two seconds and takes the same mags as the P-9.",
   "pellets": 1,
   "stockTarget": {
    "damage": 11,
    "rpm": 450,
    "vel": 350,
    "range": 40,
    "recV": 130,
    "recH": 280,
    "ergo": 80,
    "weight": 0.95,
    "noise": 64,
    "reload": 1.2,
    "price": 480
   },
   "slots": [
    {
     "id": "barrel",
     "label": "Barrel",
     "types": [
      "barrel"
     ],
     "mounts": [
      "b-p11"
     ],
     "req": true
    },
    {
     "id": "optic",
     "label": "Optic",
     "types": [
      "optic"
     ],
     "mounts": [
      "plate"
     ]
    },
    {
     "id": "tactical",
     "label": "Tactical",
     "types": [
      "tactical"
     ],
     "mounts": [
      "rail"
     ]
    },
    {
     "id": "stock",
     "label": "Stock",
     "types": [
      "stock"
     ],
     "mounts": [
      "st-p11"
     ]
    },
    {
     "id": "mag",
     "label": "Magazine",
     "types": [
      "magazine"
     ],
     "mounts": [
      "m-kenji9"
     ],
     "req": true
    }
   ],
   "defaults": {
    "barrel": "p11_bar_std",
    "mag": "k9_mag17"
   },
   "presets": [
    {
     "name": "Room broom",
     "parts": {
      "barrel": "p11_bar_thread",
      "barrel/muzzle": "m9_comp",
      "stock": "p11_stock",
      "mag": "k9_mag33"
     }
    },
    {
     "name": "Pocket rocket",
     "parts": {
      "barrel": "p11_bar_std",
      "optic": "opt_pin",
      "tactical": "tac_laser",
      "mag": "k9_mag24"
     }
    }
   ],
   "draw": {
    "body": "pistol",
    "R": 21,
    "H": 3.6,
    "bore": 2.6,
    "grip": [
     1.8,
     10.5,
     16
    ],
    "top": 8,
    "tac": 14
   },
   "base": {
    "damage": 11,
    "rpm": 450,
    "vel": 350,
    "range": 40,
    "recV": 130,
    "recH": 280,
    "ergo": 81,
    "weight": 0.72,
    "noise": 64,
    "reload": 1.143,
    "price": 395,
    "len": 21
   }
  },
  {
   "id": "k5",
   "name": "K-5 Kaze",
   "maker": "kenji",
   "cls": "smg",
   "based": "Roller-delayed SMG (MP5-type)",
   "caliber": "9x19",
   "modes": [
    "semi",
    "burst",
    "auto"
   ],
   "role": "Quiet SMG",
   "blurb": "Accurate and soft-shooting. The integral-suppressor barrel makes it the quietest gun here.",
   "pellets": 1,
   "stockTarget": {
    "damage": 12,
    "rpm": 460,
    "vel": 400,
    "range": 60,
    "recV": 55,
    "recH": 150,
    "ergo": 74,
    "weight": 2.7,
    "noise": 58,
    "reload": 1.8,
    "price": 820
   },
   "slots": [
    {
     "id": "barrel",
     "label": "Barrel",
     "types": [
      "barrel"
     ],
     "mounts": [
      "b-k5"
     ],
     "req": true
    },
    {
     "id": "handguard",
     "label": "Handguard",
     "types": [
      "handguard"
     ],
     "mounts": [
      "hg-k5"
     ],
     "req": true
    },
    {
     "id": "stock",
     "label": "Stock",
     "types": [
      "stock"
     ],
     "mounts": [
      "st-k5"
     ]
    },
    {
     "id": "mag",
     "label": "Magazine",
     "types": [
      "magazine"
     ],
     "mounts": [
      "m-k5"
     ],
     "req": true
    },
    {
     "id": "mount",
     "label": "Top mount",
     "types": [
      "mount"
     ],
     "mounts": [
      "claw-k5"
     ]
    }
   ],
   "defaults": {
    "barrel": "k5_bar_std",
    "handguard": "k5_hg_slim",
    "stock": "k5_st_fixed",
    "mag": "k5_mag30"
   },
   "presets": [
    {
     "name": "Silent",
     "parts": {
      "barrel": "k5_bar_sd",
      "handguard": "k5_hg_slim",
      "stock": "k5_st_retract",
      "mag": "k5_mag30",
      "mount": "mnt_claw",
      "mount/optic": "opt_holo"
     }
    },
    {
     "name": "Tactical",
     "parts": {
      "barrel": "k5_bar_std",
      "barrel/muzzle": "m9_comp",
      "handguard": "k5_hg_tri",
      "handguard/foregrip": "fg_vert",
      "handguard/tactical": "tac_light",
      "stock": "k5_st_fixed",
      "mag": "k5_mag50",
      "mount": "mnt_claw",
      "mount/optic": "opt_reflex"
     }
    }
   ],
   "draw": {
    "body": "smg",
    "R": 30,
    "H": 5.4,
    "bore": 3.8,
    "grip": [
     9,
     9.5,
     14
    ],
    "mx": 17,
    "top": 12,
    "sy": [
     1.2,
     5
    ]
   },
   "base": {
    "damage": 12,
    "rpm": 460,
    "vel": 400,
    "range": 60,
    "recV": 76.4,
    "recH": 208.3,
    "ergo": 72,
    "weight": 1.62,
    "noise": 58,
    "reload": 1.8,
    "price": 630,
    "len": 30
   }
  },
  {
   "id": "s10",
   "name": "S-10 Alley Cat",
   "maker": "sumida",
   "cls": "smg",
   "based": "Open-bolt machine pistol (MAC-10-type)",
   "caliber": "9x19",
   "modes": [
    "auto"
   ],
   "role": "Gang spray",
   "blurb": "Cheap, boxy, a hose of 9 mm. What the Oni carry. Hits anything close and nothing far.",
   "pellets": 1,
   "stockTarget": {
    "damage": 10,
    "rpm": 560,
    "vel": 300,
    "range": 32,
    "moa": 18,
    "recV": 120,
    "recH": 320,
    "ergo": 70,
    "weight": 2.9,
    "noise": 66,
    "reload": 1.7,
    "price": 380
   },
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "t-9mm"
     ]
    },
    {
     "id": "optic",
     "label": "Optic",
     "types": [
      "optic",
      "mount"
     ],
     "mounts": [
      "rail"
     ]
    },
    {
     "id": "stock",
     "label": "Stock",
     "types": [
      "stock"
     ],
     "mounts": [
      "st-s10"
     ]
    },
    {
     "id": "foregrip",
     "label": "Front strap",
     "types": [
      "foregrip"
     ],
     "mounts": [
      "strap-s10"
     ]
    },
    {
     "id": "mag",
     "label": "Magazine",
     "types": [
      "magazine"
     ],
     "mounts": [
      "m-s10"
     ],
     "req": true
    }
   ],
   "defaults": {
    "mag": "s10_mag32"
   },
   "presets": [
    {
     "name": "Gang spec",
     "parts": {
      "muzzle": "m9_comp",
      "foregrip": "s10_strap",
      "mag": "s10_mag32"
     }
    },
    {
     "name": "Hush",
     "parts": {
      "muzzle": "s9_long",
      "stock": "s10_stock",
      "optic": "opt_reflex",
      "foregrip": "s10_strap",
      "mag": "s10_mag32"
     }
    }
   ],
   "draw": {
    "body": "mac",
    "R": 25,
    "H": 6.8,
    "bore": 5.2,
    "grip": [
     8,
     9,
     4
    ],
    "stub": 2.5,
    "top": 11,
    "sy": [
     3.5,
     6.4
    ]
   },
   "base": {
    "damage": 10,
    "rpm": 560,
    "vel": 300,
    "range": 32,
    "recV": 120,
    "recH": 320,
    "ergo": 72,
    "weight": 2.7,
    "noise": 66,
    "reload": 1.619,
    "price": 355,
    "len": 27.5,
    "moa": 18
   }
  }
 ],
 "parts": {
  "ak_dc_rail": {
   "name": "Severka railed dust cover",
   "maker": "severka",
   "type": "dustcover",
   "mount": "dc-ak",
   "price": 150,
   "mod": {
    "ergo": -1
   },
   "weight": 0.3,
   "slots": [
    {
     "id": "optic",
     "label": "Optic",
     "types": [
      "optic",
      "mount"
     ],
     "mounts": [
      "rail"
     ]
    }
   ],
   "note": "Puts a top rail on any Severka.",
   "draw": {
    "s": "railcover"
   }
  },
  "ak_dc_std": {
   "name": "Severka stamped dust cover",
   "maker": "severka",
   "type": "dustcover",
   "mount": "dc-ak",
   "price": 30,
   "weight": 0.2,
   "draw": {
    "s": "cover"
   }
  },
  "ak_hg_poly": {
   "name": "Severka ribbed polymer handguard",
   "maker": "severka",
   "type": "handguard",
   "mount": "hg-ak",
   "price": 80,
   "mod": {
    "ergo": 1
   },
   "weight": 0.25,
   "slots": [
    {
     "id": "foregrip",
     "label": "Foregrip",
     "types": [
      "foregrip"
     ],
     "mounts": [
      "rail"
     ]
    }
   ],
   "draw": {
    "s": "poly",
    "l": 22,
    "h": 4.2
   }
  },
  "ak_hg_quad": {
   "name": "Hachi AK quad rail",
   "maker": "hachi",
   "type": "handguard",
   "mount": "hg-ak",
   "price": 160,
   "mod": {
    "ergo": -2
   },
   "weight": 0.45,
   "slots": [
    {
     "id": "foregrip",
     "label": "Foregrip",
     "types": [
      "foregrip"
     ],
     "mounts": [
      "rail"
     ]
    },
    {
     "id": "tactical",
     "label": "Tactical",
     "types": [
      "tactical"
     ],
     "mounts": [
      "rail"
     ]
    }
   ],
   "draw": {
    "s": "quad",
    "l": 22,
    "h": 4.8
   }
  },
  "ak_hg_slot": {
   "name": "Halvard Slotline AK",
   "maker": "halvard",
   "type": "handguard",
   "mount": "hg-ak",
   "price": 240,
   "mod": {
    "ergo": 2
   },
   "weight": 0.28,
   "slots": [
    {
     "id": "railA",
     "label": "Rail slot A",
     "types": [
      "rail"
     ],
     "mounts": [
      "slot"
     ]
    },
    {
     "id": "railB",
     "label": "Rail slot B",
     "types": [
      "rail"
     ],
     "mounts": [
      "slot"
     ]
    }
   ],
   "note": "Light and long; add rail sections where you need them.",
   "draw": {
    "s": "slot",
    "l": 30,
    "h": 4.4
   },
   "conflicts": [
    "v47_bar_short"
   ]
  },
  "ak_hg_wood": {
   "name": "Severka birch handguard",
   "maker": "severka",
   "type": "handguard",
   "mount": "hg-ak",
   "price": 40,
   "weight": 0.3,
   "draw": {
    "s": "wood",
    "l": 22,
    "h": 4.2
   }
  },
  "ak_pg_erg": {
   "name": "Halvard ergo grip (Severka fit)",
   "maker": "halvard",
   "type": "grip",
   "mount": "pg-ak",
   "price": 70,
   "mod": {
    "ergo": 4
   },
   "weight": 0.07,
   "draw": {
    "s": "grip",
    "a": 12
   }
  },
  "ak_pg_rub": {
   "name": "Hachi rubber grip (Severka fit)",
   "maker": "hachi",
   "type": "grip",
   "mount": "pg-ak",
   "price": 45,
   "mod": {
    "ergo": 2,
    "recoil": -1
   },
   "weight": 0.09,
   "draw": {
    "s": "grip"
   }
  },
  "ak_pg_std": {
   "name": "Severka bakelite grip",
   "maker": "severka",
   "type": "grip",
   "mount": "pg-ak",
   "price": 20,
   "weight": 0.08,
   "draw": {
    "s": "grip",
    "m": "wood"
   }
  },
  "ak_st_adapter": {
   "name": "Hachi Severka-to-Halvard tube adapter",
   "maker": "hachi",
   "type": "stock",
   "mount": "st-ak",
   "price": 90,
   "mod": {
    "ergo": -1
   },
   "weight": 0.18,
   "len": 4,
   "slots": [
    {
     "id": "stock",
     "label": "Halvard stock",
     "types": [
      "stock"
     ],
     "mounts": [
      "st-ar"
     ]
    }
   ],
   "note": "Takes any Halvard stock.",
   "draw": {
    "s": "adapter",
    "l": 17
   }
  },
  "ak_st_fold": {
   "name": "Severka side-folder",
   "maker": "severka",
   "type": "stock",
   "mount": "st-ak",
   "price": 140,
   "mod": {
    "ergo": 4,
    "recoil": -24
   },
   "weight": 0.35,
   "len": 22,
   "note": "Folds to fit a car window.",
   "draw": {
    "s": "folder",
    "l": 22
   }
  },
  "ak_st_poly": {
   "name": "Severka polymer stock",
   "maker": "severka",
   "type": "stock",
   "mount": "st-ak",
   "price": 60,
   "mod": {
    "ergo": 2,
    "recoil": -30
   },
   "weight": 0.4,
   "len": 24,
   "draw": {
    "s": "solid",
    "l": 24
   }
  },
  "ak_st_skel": {
   "name": "Severka skeleton stock",
   "maker": "severka",
   "type": "stock",
   "mount": "st-ak",
   "price": 190,
   "mod": {
    "ergo": 6,
    "recoil": -22
   },
   "weight": 0.25,
   "len": 23,
   "draw": {
    "s": "skeleton",
    "l": 23
   }
  },
  "ak_st_wood": {
   "name": "Severka laminated stock",
   "maker": "severka",
   "type": "stock",
   "mount": "st-ak",
   "price": 70,
   "mod": {
    "recoil": -32
   },
   "weight": 0.6,
   "len": 24,
   "draw": {
    "s": "solid",
    "l": 24,
    "m": "wood"
   }
  },
  "ar_st_carb": {
   "name": "Halvard carbine stock",
   "maker": "halvard",
   "type": "stock",
   "mount": "st-ar",
   "price": 70,
   "mod": {
    "ergo": 2,
    "recoil": -26
   },
   "weight": 0.25,
   "len": 20,
   "draw": {
    "s": "carb",
    "l": 20
   }
  },
  "ar_st_mini": {
   "name": "Halvard minimalist stock",
   "maker": "halvard",
   "type": "stock",
   "mount": "st-ar",
   "price": 150,
   "mod": {
    "ergo": 6,
    "recoil": -18
   },
   "weight": 0.12,
   "len": 16,
   "draw": {
    "s": "mini",
    "l": 16
   }
  },
  "ar_st_prec": {
   "name": "Oshiro precision stock",
   "maker": "oshiro",
   "type": "stock",
   "mount": "st-ar",
   "price": 240,
   "mod": {
    "ergo": -2,
    "recoil": -32
   },
   "weight": 0.55,
   "len": 24,
   "draw": {
    "s": "prec",
    "l": 24
   }
  },
  "ch12_tight": {
   "name": "Sumida tight choke",
   "maker": "sumida",
   "type": "muzzle",
   "mount": "choke-12",
   "price": 70,
   "mod": {
    "acc": -25
   },
   "weight": 0.05,
   "len": 2,
   "note": "Tighter pellet pattern.",
   "draw": {
    "s": "choke",
    "l": 2
   }
  },
  "ch12_wide": {
   "name": "Sumida spreader choke",
   "maker": "sumida",
   "type": "muzzle",
   "mount": "choke-12",
   "price": 60,
   "mod": {
    "acc": 30
   },
   "weight": 0.05,
   "len": 2,
   "note": "Wider pattern for crowds and car doors.",
   "draw": {
    "s": "choke",
    "l": 2
   }
  },
  "fg_angled": {
   "name": "Halvard angled grip",
   "maker": "halvard",
   "type": "foregrip",
   "mount": "rail",
   "price": 70,
   "mod": {
    "ergo": 4,
    "recoil": -2
   },
   "weight": 0.08,
   "draw": {
    "s": "angled"
   }
  },
  "fg_gyro": {
   "name": "Kanemori Gyro-Grip",
   "maker": "kanemori",
   "type": "foregrip",
   "mount": "rail",
   "price": 520,
   "mod": {
    "ergo": -2,
    "recoil": -9
   },
   "weight": 0.34,
   "note": "Gyro-stabilised. Heavy and expensive.",
   "draw": {
    "s": "gyro"
   }
  },
  "fg_stop": {
   "name": "Oshiro handstop",
   "maker": "oshiro",
   "type": "foregrip",
   "mount": "rail",
   "price": 35,
   "mod": {
    "ergo": 2,
    "recoil": -1
   },
   "weight": 0.03,
   "draw": {
    "s": "stop"
   }
  },
  "fg_vert": {
   "name": "Hachi vertical grip",
   "maker": "hachi",
   "type": "foregrip",
   "mount": "rail",
   "price": 45,
   "mod": {
    "ergo": 1,
    "recoil": -4
   },
   "weight": 0.12,
   "draw": {
    "s": "vert"
   }
  },
  "m12_20": {
   "name": "VS-12 20-round drum",
   "maker": "severka",
   "type": "magazine",
   "mount": "m-12box",
   "price": 300,
   "mod": {
    "ergo": -10,
    "reload": 40
   },
   "weight": 1.8,
   "cap": 20,
   "draw": {
    "s": "drum",
    "l": 18
   }
  },
  "m12_5": {
   "name": "VS-12 5-round box",
   "maker": "severka",
   "type": "magazine",
   "mount": "m-12box",
   "price": 30,
   "weight": 0.25,
   "cap": 5,
   "draw": {
    "s": "box",
    "l": 9
   }
  },
  "m12_8": {
   "name": "VS-12 8-round box",
   "maker": "severka",
   "type": "magazine",
   "mount": "m-12box",
   "price": 50,
   "mod": {
    "ergo": -2,
    "reload": 4
   },
   "weight": 0.4,
   "cap": 8,
   "draw": {
    "s": "box",
    "l": 14
   }
  },
  "m12_brake": {
   "name": "Sumida 12-gauge brake",
   "maker": "sumida",
   "type": "muzzle",
   "mount": "t-12ga",
   "price": 110,
   "mod": {
    "recoil": -12,
    "noise": 4
   },
   "weight": 0.18,
   "len": 6,
   "draw": {
    "s": "brake",
    "l": 6,
    "d": 3
   }
  },
  "m762r_20": {
   "name": "V-47 20-round mag",
   "maker": "severka",
   "type": "magazine",
   "mount": "m-762r",
   "price": 25,
   "mod": {
    "reload": -4
   },
   "weight": 0.2,
   "cap": 20,
   "draw": {
    "s": "curved",
    "l": 15,
    "c": 4
   }
  },
  "m762r_30": {
   "name": "V-47 30-round mag",
   "maker": "severka",
   "type": "magazine",
   "mount": "m-762r",
   "price": 35,
   "weight": 0.3,
   "cap": 30,
   "draw": {
    "s": "curved",
    "l": 21,
    "c": 6
   }
  },
  "m762r_75": {
   "name": "V-47 75-round drum",
   "maker": "severka",
   "type": "magazine",
   "mount": "m-762r",
   "price": 280,
   "mod": {
    "ergo": -10,
    "reload": 35
   },
   "weight": 1.6,
   "cap": 75,
   "draw": {
    "s": "drum",
    "l": 16
   }
  },
  "m762r_brake": {
   "name": "Severka 47 slant brake",
   "maker": "severka",
   "type": "muzzle",
   "mount": "t-762r",
   "price": 45,
   "mod": {
    "recoil": -8,
    "noise": 3
   },
   "weight": 0.08,
   "len": 3,
   "draw": {
    "s": "brake",
    "l": 3
   }
  },
  "mnt_rings": {
   "name": "Oshiro 30 mm ring mount",
   "maker": "oshiro",
   "type": "mount",
   "mount": "rail",
   "price": 110,
   "mod": {
    "ergo": -1
   },
   "weight": 0.2,
   "slots": [
    {
     "id": "scope",
     "label": "Scope",
     "types": [
      "optic"
     ],
     "mounts": [
      "rings"
     ]
    }
   ],
   "note": "Holds a magnified scope.",
   "draw": {
    "s": "rings",
    "l": 12,
    "h": 2
   }
  },
  "opt_holo": {
   "name": "Mirai Holo H2",
   "maker": "mirai",
   "type": "optic",
   "mount": "rail",
   "price": 260,
   "mod": {
    "ergo": -2,
    "acc": -7
   },
   "weight": 0.32,
   "zoom": 1,
   "draw": {
    "s": "holo",
    "l": 9,
    "h": 5
   }
  },
  "opt_link": {
   "name": "Kanemori Linkeye",
   "maker": "kanemori",
   "type": "optic",
   "mount": "rail",
   "price": 700,
   "mod": {
    "ergo": -2,
    "acc": -4
   },
   "weight": 0.25,
   "zoom": 1.5,
   "fx": {
    "lockRange": 25
   },
   "note": "Smart weapons lock 25% farther.",
   "draw": {
    "s": "link",
    "l": 8,
    "h": 4.5
   }
  },
  "opt_long": {
   "name": "Oshiro Takane 5–25×",
   "maker": "oshiro",
   "type": "optic",
   "mount": "rings",
   "price": 980,
   "mod": {
    "ergo": -8,
    "acc": -15
   },
   "weight": 0.95,
   "zoom": 25,
   "note": "Needs a ring mount.",
   "draw": {
    "s": "scope",
    "l": 36,
    "h": 5.6
   }
  },
  "opt_lpvo": {
   "name": "Oshiro Kaname 1–6×",
   "maker": "oshiro",
   "type": "optic",
   "mount": "rings",
   "price": 620,
   "mod": {
    "ergo": -5,
    "acc": -12
   },
   "weight": 0.58,
   "zoom": 6,
   "note": "Needs a ring mount.",
   "draw": {
    "s": "scope",
    "l": 26,
    "h": 4.4
   }
  },
  "opt_prism": {
   "name": "Mirai Prism 3×",
   "maker": "mirai",
   "type": "optic",
   "mount": "rail",
   "price": 420,
   "mod": {
    "ergo": -3,
    "acc": -10
   },
   "weight": 0.38,
   "zoom": 3,
   "draw": {
    "s": "prism",
    "l": 9,
    "h": 5
   }
  },
  "opt_reflex": {
   "name": "Hachi open reflex",
   "maker": "hachi",
   "type": "optic",
   "mount": "rail",
   "price": 90,
   "mod": {
    "ergo": -1,
    "acc": -5
   },
   "weight": 0.08,
   "zoom": 1,
   "draw": {
    "s": "reflex",
    "l": 4.5,
    "h": 3
   }
  },
  "opt_thermal": {
   "name": "Mirai Ghost thermal 2×",
   "maker": "mirai",
   "type": "optic",
   "mount": "rail",
   "price": 1150,
   "mod": {
    "ergo": -4,
    "acc": -6
   },
   "weight": 0.62,
   "zoom": 2,
   "note": "Shows warm bodies through smoke and darkness.",
   "draw": {
    "s": "thermal",
    "l": 13,
    "h": 6
   }
  },
  "rail_sec": {
   "name": "Hachi 3-slot rail section",
   "maker": "hachi",
   "type": "rail",
   "mount": "slot",
   "price": 25,
   "weight": 0.03,
   "slots": [
    {
     "id": "acc",
     "label": "Accessory",
     "types": [
      "foregrip",
      "tactical"
     ],
     "mounts": [
      "rail"
     ]
    }
   ],
   "note": "Bolts into a Slotline slot so it takes a grip or light.",
   "draw": {
    "s": "rail"
   }
  },
  "s12": {
   "name": "Sumida Mute-12 suppressor",
   "maker": "sumida",
   "type": "suppressor",
   "mount": "t-12ga",
   "price": 520,
   "mod": {
    "ergo": -7,
    "recoil": -10,
    "noise": -24
   },
   "weight": 0.75,
   "len": 22,
   "draw": {
    "s": "can",
    "l": 22,
    "d": 4.4
   }
  },
  "s762r": {
   "name": "Severka Tishina-7 suppressor",
   "maker": "severka",
   "type": "suppressor",
   "mount": "t-762r",
   "price": 480,
   "mod": {
    "ergo": -6,
    "recoil": -9,
    "vel": 2,
    "noise": -28
   },
   "weight": 0.6,
   "len": 20,
   "draw": {
    "s": "can",
    "l": 20,
    "d": 3.8
   }
  },
  "tac_combo": {
   "name": "Mirai Duo light/laser",
   "maker": "mirai",
   "type": "tactical",
   "mount": "rail",
   "price": 260,
   "mod": {
    "ergo": -2,
    "acc": -8
   },
   "weight": 0.16,
   "note": "Light and aim line in one.",
   "draw": {
    "s": "combo"
   }
  },
  "tac_laser": {
   "name": "Kenji Redline laser",
   "maker": "kenji",
   "type": "tactical",
   "mount": "rail",
   "price": 140,
   "mod": {
    "ergo": -1,
    "acc": -8
   },
   "weight": 0.07,
   "note": "Shows an aim line.",
   "draw": {
    "s": "laser"
   }
  },
  "tac_light": {
   "name": "Hachi Lantern light",
   "maker": "hachi",
   "type": "tactical",
   "mount": "rail",
   "price": 60,
   "mod": {
    "ergo": -1
   },
   "weight": 0.11,
   "note": "Lights a cone ahead; you're spotted 15% farther while it's on.",
   "draw": {
    "s": "light"
   }
  },
  "v47_bar_short": {
   "name": "V-47 short barrel",
   "maker": "severka",
   "type": "barrel",
   "mount": "b-v47",
   "price": 170,
   "mod": {
    "ergo": 3,
    "recoil": 6,
    "vel": -11
   },
   "weight": 0.6,
   "len": 22,
   "moa": 7.2,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "t-762r"
     ]
    }
   ],
   "conflicts": [
    "ak_hg_slot"
   ],
   "note": "Too short for the long Slotline handguard.",
   "draw": {
    "s": "bar",
    "l": 22
   }
  },
  "v47_bar_std": {
   "name": "V-47 standard barrel",
   "maker": "severka",
   "type": "barrel",
   "mount": "b-v47",
   "price": 110,
   "weight": 0.8,
   "len": 30,
   "moa": 6,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "t-762r"
     ]
    }
   ],
   "draw": {
    "s": "bar",
    "l": 30
   }
  },
  "vs12_bar_long": {
   "name": "VS-12 580 mm barrel",
   "maker": "severka",
   "type": "barrel",
   "mount": "b-vs12",
   "price": 200,
   "mod": {
    "ergo": -4,
    "vel": 6
   },
   "weight": 1.2,
   "len": 54,
   "moa": 28,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "choke-12",
      "t-12ga"
     ]
    }
   ],
   "draw": {
    "s": "bar",
    "l": 54,
    "t": 1.8
   }
  },
  "vs12_bar_std": {
   "name": "VS-12 430 mm barrel",
   "maker": "severka",
   "type": "barrel",
   "mount": "b-vs12",
   "price": 120,
   "weight": 0.9,
   "len": 40,
   "moa": 34,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "choke-12",
      "t-12ga"
     ]
    }
   ],
   "draw": {
    "s": "bar",
    "l": 40,
    "t": 1.8
   }
  },
  "p11_bar_std": {
   "name": "P-11 standard barrel",
   "maker": "kenji",
   "type": "barrel",
   "mount": "b-p11",
   "price": 50,
   "weight": 0.12,
   "moa": 11,
   "draw": {
    "s": "pbar",
    "l": 0
   }
  },
  "p11_bar_thread": {
   "name": "P-11 threaded barrel",
   "maker": "kenji",
   "type": "barrel",
   "mount": "b-p11",
   "price": 100,
   "mod": {
    "vel": 2
   },
   "weight": 0.13,
   "len": 1.5,
   "moa": 11,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "t-9mm"
     ]
    }
   ],
   "note": "Takes 9 mm muzzle devices and suppressors.",
   "draw": {
    "s": "pbar",
    "l": 1.5
   }
  },
  "m9_comp": {
   "name": "Kenji Hop compensator",
   "maker": "kenji",
   "type": "muzzle",
   "mount": "t-9mm",
   "price": 90,
   "mod": {
    "recoil": -8,
    "noise": 4
   },
   "weight": 0.06,
   "len": 3,
   "draw": {
    "s": "comp",
    "l": 3,
    "d": 2.2
   }
  },
  "s9_short": {
   "name": "Hachi Hush-9 suppressor",
   "maker": "hachi",
   "type": "suppressor",
   "mount": "t-9mm",
   "price": 280,
   "mod": {
    "ergo": -3,
    "recoil": -4,
    "vel": 1,
    "noise": -26
   },
   "weight": 0.18,
   "len": 11,
   "draw": {
    "s": "can",
    "l": 11,
    "d": 2.8
   }
  },
  "s9_long": {
   "name": "Oshiro Shizuka-9 suppressor",
   "maker": "oshiro",
   "type": "suppressor",
   "mount": "t-9mm",
   "price": 420,
   "mod": {
    "ergo": -5,
    "recoil": -7,
    "vel": 2,
    "noise": -34
   },
   "weight": 0.28,
   "len": 17,
   "draw": {
    "s": "can",
    "l": 17,
    "d": 3.2
   }
  },
  "opt_pin": {
   "name": "Kenji Pin micro dot",
   "maker": "kenji",
   "type": "optic",
   "mount": "plate",
   "price": 120,
   "mod": {
    "ergo": -1,
    "acc": -6
   },
   "weight": 0.03,
   "zoom": 1,
   "draw": {
    "s": "dot",
    "l": 2.6,
    "h": 1.6
   }
  },
  "p11_stock": {
   "name": "P-11 shoulder stock",
   "maker": "kenji",
   "type": "stock",
   "mount": "st-p11",
   "price": 160,
   "mod": {
    "ergo": -6,
    "recoil": -25
   },
   "weight": 0.35,
   "len": 28,
   "draw": {
    "s": "wire",
    "l": 28
   }
  },
  "k9_mag12": {
   "name": "Kenji 12-round flush mag",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-kenji9",
   "price": 20,
   "weight": 0.08,
   "cap": 12,
   "draw": {
    "s": "pmag",
    "l": 0
   }
  },
  "k9_mag17": {
   "name": "Kenji 17-round extended mag",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-kenji9",
   "price": 35,
   "mod": {
    "ergo": -1,
    "reload": 5
   },
   "weight": 0.11,
   "cap": 17,
   "draw": {
    "s": "pmag",
    "l": 2.5
   }
  },
  "k9_mag24": {
   "name": "Kenji 24-round stick mag",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-kenji9",
   "price": 55,
   "mod": {
    "ergo": -3,
    "reload": 10
   },
   "weight": 0.15,
   "cap": 24,
   "draw": {
    "s": "pmag",
    "l": 6
   }
  },
  "k9_mag33": {
   "name": "Kenji 33-round long stick",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-kenji9",
   "price": 80,
   "mod": {
    "ergo": -5,
    "reload": 15
   },
   "weight": 0.2,
   "cap": 33,
   "draw": {
    "s": "pmag",
    "l": 11
   }
  },
  "k5_bar_std": {
   "name": "K-5 standard barrel",
   "maker": "kenji",
   "type": "barrel",
   "mount": "b-k5",
   "price": 60,
   "weight": 0.3,
   "len": 16,
   "moa": 6.5,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "t-9mm"
     ]
    }
   ],
   "draw": {
    "s": "bar",
    "l": 16,
    "t": 1.1
   }
  },
  "k5_bar_short": {
   "name": "K-5 short barrel",
   "maker": "kenji",
   "type": "barrel",
   "mount": "b-k5",
   "price": 140,
   "mod": {
    "ergo": 3,
    "recoil": 5,
    "vel": -8
   },
   "weight": 0.22,
   "len": 9,
   "moa": 8,
   "slots": [
    {
     "id": "muzzle",
     "label": "Muzzle",
     "types": [
      "muzzle",
      "suppressor"
     ],
     "mounts": [
      "t-9mm"
     ]
    }
   ],
   "draw": {
    "s": "bar",
    "l": 9,
    "t": 1.1
   }
  },
  "k5_bar_sd": {
   "name": "K-5 integral suppressor barrel",
   "maker": "kenji",
   "type": "barrel",
   "mount": "b-k5",
   "price": 520,
   "mod": {
    "ergo": -4,
    "recoil": -10,
    "vel": -18,
    "noise": -32
   },
   "weight": 0.65,
   "len": 28,
   "moa": 7.5,
   "conflicts": [
    "k5_hg_tri"
   ],
   "note": "Subsonic and very quiet. Only fits the slimline handguard.",
   "draw": {
    "s": "sdbar",
    "l": 28,
    "d": 3.4
   }
  },
  "k5_hg_slim": {
   "name": "K-5 slimline handguard",
   "maker": "kenji",
   "type": "handguard",
   "mount": "hg-k5",
   "price": 30,
   "weight": 0.15,
   "draw": {
    "s": "slim",
    "l": 13,
    "h": 3.4
   }
  },
  "k5_hg_tri": {
   "name": "K-5 tri-rail handguard",
   "maker": "kenji",
   "type": "handguard",
   "mount": "hg-k5",
   "price": 120,
   "mod": {
    "ergo": -1
   },
   "weight": 0.25,
   "slots": [
    {
     "id": "foregrip",
     "label": "Foregrip",
     "types": [
      "foregrip"
     ],
     "mounts": [
      "rail"
     ]
    },
    {
     "id": "tactical",
     "label": "Tactical",
     "types": [
      "tactical"
     ],
     "mounts": [
      "rail"
     ]
    }
   ],
   "draw": {
    "s": "quad",
    "l": 13,
    "h": 3.8
   },
   "conflicts": [
    "k5_bar_sd"
   ]
  },
  "k5_st_fixed": {
   "name": "K-5 fixed stock",
   "maker": "kenji",
   "type": "stock",
   "mount": "st-k5",
   "price": 70,
   "mod": {
    "ergo": 2,
    "recoil": -28
   },
   "weight": 0.45,
   "len": 22,
   "draw": {
    "s": "solid",
    "l": 22
   }
  },
  "k5_st_retract": {
   "name": "K-5 retractable stock",
   "maker": "kenji",
   "type": "stock",
   "mount": "st-k5",
   "price": 140,
   "mod": {
    "ergo": 5,
    "recoil": -20
   },
   "weight": 0.3,
   "len": 14,
   "draw": {
    "s": "wire",
    "l": 14
   }
  },
  "k5_mag15": {
   "name": "K-5 15-round mag",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-k5",
   "price": 20,
   "mod": {
    "reload": -5
   },
   "weight": 0.1,
   "cap": 15,
   "draw": {
    "s": "curved",
    "l": 10,
    "c": 2
   }
  },
  "k5_mag30": {
   "name": "K-5 30-round mag",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-k5",
   "price": 30,
   "weight": 0.18,
   "cap": 30,
   "draw": {
    "s": "curved",
    "l": 18,
    "c": 4
   }
  },
  "k5_mag50": {
   "name": "K-5 50-round drum",
   "maker": "kenji",
   "type": "magazine",
   "mount": "m-k5",
   "price": 160,
   "mod": {
    "ergo": -6,
    "reload": 30
   },
   "weight": 0.6,
   "cap": 50,
   "draw": {
    "s": "drum",
    "l": 12
   }
  },
  "mnt_claw": {
   "name": "K-5 claw rail",
   "maker": "kenji",
   "type": "mount",
   "mount": "claw-k5",
   "price": 80,
   "mod": {
    "ergo": -1
   },
   "weight": 0.15,
   "slots": [
    {
     "id": "optic",
     "label": "Optic",
     "types": [
      "optic",
      "mount"
     ],
     "mounts": [
      "rail"
     ]
    }
   ],
   "note": "Adds a top rail to the K-5.",
   "draw": {
    "s": "claw",
    "l": 12,
    "h": 1.6
   }
  },
  "s10_stock": {
   "name": "S-10 wire stock",
   "maker": "sumida",
   "type": "stock",
   "mount": "st-s10",
   "price": 60,
   "mod": {
    "ergo": -3,
    "recoil": -22
   },
   "weight": 0.25,
   "len": 24,
   "draw": {
    "s": "wire",
    "l": 24
   }
  },
  "s10_strap": {
   "name": "S-10 front strap",
   "maker": "sumida",
   "type": "foregrip",
   "mount": "strap-s10",
   "price": 10,
   "mod": {
    "ergo": 2,
    "recoil": -5
   },
   "weight": 0.02,
   "note": "A loop of nylon to hold the front. Old trick.",
   "draw": {
    "s": "strap"
   }
  },
  "s10_mag16": {
   "name": "S-10 16-round mag",
   "maker": "sumida",
   "type": "magazine",
   "mount": "m-s10",
   "price": 15,
   "weight": 0.12,
   "cap": 16,
   "draw": {
    "s": "gmag",
    "l": 3
   }
  },
  "s10_mag32": {
   "name": "S-10 32-round mag",
   "maker": "sumida",
   "type": "magazine",
   "mount": "m-s10",
   "price": 25,
   "mod": {
    "ergo": -2,
    "reload": 5
   },
   "weight": 0.2,
   "cap": 32,
   "draw": {
    "s": "gmag",
    "l": 12
   }
  }
 }
}
